import $ from 'jquery';
import state from './state';
import { updateLoadedSlides } from './utils';

/**
 *
 * @param {"next"|"prev"} direction
 * @param {*}             slider
 * @param {*}             onResponse
 * @param                 onError
 */
export function loadSlides(
	direction,
	slider,
	onResponse,
	onError = ( request, status, error ) =>
		console.log( 'onError', error, request, status )
) {
	const sliderId = $( slider ).attr( 'id' );
	let ajaxUrl = state.get( sliderId, 'ajaxurl' );
	const attributes = state.getState( sliderId );
	const nonce = state.get( sliderId, 'nonce' );

	const hostname = window.location.hostname;

	const PROXIED_DOMAINS = [
		'esero.at',
		'www.esero.at',
		'www.starts-prize.aec.at',
		'starts-prize.aec.at',
		'www.criticalchangelab.eu',
		'criticalchangelab.eu'
	];
	if ( PROXIED_DOMAINS.includes( hostname ) ) {

		// Use direct path for proxied domains
		ajaxUrl = '/wp-admin/admin-ajax.php';
	}

	const data = {
		action: `dynamic_slider_load_${direction}`,
		attributes,
		_ajax_nonce: nonce
	};

	$.ajax({
		type: 'POST',
		dataType: 'json',
		url: ajaxUrl,
		data,
		success: ( res ) => onResponse( res, slider ),
		error: onError
	});
}

export function preloadSlidesPrev( slider, onLoadSucces ) {
	$( slider ).addClass( 'prev-loading' );

	updateLoadedSlides( slider );

	loadSlides( 'prev', slider, onLoadSucces );
}

export function preloadSlidesNext( slider, onLoadSuccess ) {
	$( slider ).addClass( 'next-loading' );

	updateLoadedSlides( slider );

	loadSlides( 'next', slider, onLoadSuccess );
}
